import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api, setAuthToken } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [operator, setOperator] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    api.get("/auth/me")
      .then((res) => { setOperator(res.data.name); setIsAdmin(Boolean(res.data.is_admin)); })
      .catch(() => { setOperator(null); setIsAdmin(false); })
      .finally(() => setChecking(false));
    // ripristino sessione solo al mount
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const login = async (name, password) => {
    const res = await api.post("/auth/login", { name, password });
    setAuthToken(res.data.token);
    setOperator(res.data.name);
    setIsAdmin(Boolean(res.data.is_admin));
    return res.data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      if (process.env.NODE_ENV !== "production") console.debug("Logout lato server fallito (best-effort)", err);
    }
    setAuthToken(null);
    setOperator(null);
    setIsAdmin(false);
  };

  const value = useMemo(() => ({ operator, isAdmin, checking, login, logout }), [operator, isAdmin, checking]);

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
